export default __webpack_public_path__ + "static/media/rmc01.0cfc0ce1.png";